<div class="bg-gray-light mr-5 ml-5">
  <div class="">
    <img
      src="../assets/img/pcm-header-pages.png"
      alt=""
      height="150"
      width="400"
      class="mt-3"
    />
  </div>
  <hr />
  <h2 style="font-size: 2.5rem">Terms of Use</h2>
  <h1 *ngIf="!currentUser.currentTermsOfUseAccepted">
    Read through to the bottom of the page to accept these terms
  </h1>
  <div [innerHtml]="tosContent" class="p-2"></div>
  <div class="p-3" *ngIf="currentUser">
    <form
      *ngIf="!currentUser.currentTermsOfUseAccepted"
      style="width: 150px; margin: auto"
      [formGroup]="acceptForm"
      (ngSubmit)="onSubmit()"
    >
      <div class="form-group">
        <button [disabled]="loading" class="btn btn-lg btn-primary px-4">
          <app-loading-spinner [loading]="loading"></app-loading-spinner>
          Accept
        </button>
      </div>
    </form>
    <div
      class="d-flex justify-content-center"
      *ngIf="currentUser.currentTermsOfUseAccepted"
    >
      <button [disabled]="loading" (click)="goBack()" class="btn btn-primary">
        <app-loading-spinner [loading]="loading"></app-loading-spinner>
        Back
      </button>
    </div>
  </div>
</div>
